import axios from '@/axios';

const RESOURCE_NAME = '/admin/users-searches';

export default {
    getSearches(data) {
        return axios.post(`${RESOURCE_NAME}/get-searches`, data)
    },

    getAiResponses(pageParams, filters) {
        return axios.post(`${RESOURCE_NAME}/get-ai-responses`, {...pageParams, filters})
    },
}
